(function () {
	'use strict';

	/**
	* @ngdoc service
	* @name  smb-app.smbUserGroupDataStore
	* 
	* @description 
	* A datastore used to retrieve and interact with a smb-app user group
	**/

	angular
		.module('smb-app')
		.factory('smbUserGroupDataStore',
		[
			'$q',
			'pxAuthService',
			'sbUserGroupService',
			'smbSortService',
			UserGroupDataStore
		]);

	function UserGroupDataStore($q, pxAuthService, sbUserGroupService, smbSortService) {
		var _userGroup = null;

		var _newUserGroup = {
			UserGroupName: '',
			Embedded: {
				Users: []
			}
		};

		return {
			/**
			* @ngdoc method
			* @name smbUserGroupDataStore#getUserGroup
			* @methodOf smb-app.smbUserGroupDataStore
			* @kind function
			*
			* @description
			* Gets a user group
			*
			* @returns {Deferred} A promise that will resolve with a user group
			* 
			*/
			getUserGroup: getUserGroup,

			/**
			* @ngdoc method
			* @name smbUserGroupDataStore#saveUserGroup
			* @methodOf smb-app.smbUserGroupDataStore
			* @kind function
			*
			* @description
			* Saves a UserGroup
			*
			* @returns {Deferred} A promise that will resolve with a saved user group
			* 
			*/
			saveUserGroup: saveUserGroup,

			/**
			* @ngdoc method
			* @name smbUserGroupDataStore#containsUser
			* @methodOf smb-app.smbUserGroupDataStore
			* @kind function
			*
			* @description
			* Determines whether a user exists in the user group's collection of users
			*
			* @returns {boolean} A boolean represnetation of a user's existance in the user group's collection of users
			* 
			*/
			containsUser: containsUser,

			/**
			* @ngdoc property
			* @name smbUserGroupDataStore#userGroup
			* @propertyOf smb-app.smbUserGroupDataStore
			* @kind property
			*
			* @description
			* A user group
			* 
			* @returns {object} A user group
			*/
			get userGroup() { return _userGroup; }
		};

		function getUserGroup(userGroupId) {
			if (!userGroupId) {
				_userGroup = angular.copy(_newUserGroup);

				return $q.resolve(_userGroup);
			}
			return sbUserGroupService
				.getUserGroup(userGroupId, pxAuthService.systemName)
				.then(function (response) {
					response.Embedded.Users.sort(smbSortService.sortObjectByStringProperty('UserName'));
					_userGroup = response;				

					return response;
				});
		}

		function saveUserGroup() {
			if (_userGroup.UserGroupId) {
				return sbUserGroupService
					.updateUserGroup(_userGroup, pxAuthService.systemName)
					.then(function (response) {
						_userGroup = response;

						return response;
					});
			} else {
				return sbUserGroupService
					.addUserGroup(_userGroup, pxAuthService.systemName)
					.then(function (response) {
						_userGroup = response;

						return response;
					});
			}
		}

		function containsUser(user) {
			for (var i = 0; i < _userGroup.Embedded.Users.length; i++) {
				if (_userGroup.Embedded.Users[i].UserId === user.UserId) {
					return true;
				}
			}

			return false;
		}
	}

})();


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/userGroupDataStore.js
// module id = 131
// module chunks = 1